module.exports = function view (state, actions) {
  return h('nav', { class: 'navbar is-transparent' }, [
    h('div', { class: 'navbar-brand' }, [
      h('a', { class: 'navbar-item', href: '#' }, 'HYPERAPP-CUSTOMELEMENTS'),
      h('div', { class: 'navbar-burger burger', onclick: function (e) { actions.toggleMenu() } }, [
        h('span', {}),
        h('span', {}),
        h('span', {})
      ])
    ]),
    h('div', { class: 'navbar-menu', style: { display: state.showMenu ? 'block' : 'none' } }, [
      h('div', { class: 'navbar-start' }, [
        h('a', { class: 'navbar-item', href: '#' }, 'Home'),
        h('div', { class: 'navbar-item has-dropdown is-hoverable' }, [
          h('a', { class: 'navbar-link', href: '#' }, 'Docs'),
          h('div', { class: 'navbar-dropdown is-boxed' }, [
            h('a', { class: 'navbar-item', href: '#' }, 'Overview'),
            h('a', { class: 'navbar-item', href: '#' }, 'Modifiers'),
            h('a', { class: 'navbar-item', href: '#' }, 'Columns'),
            h('a', { class: 'navbar-item', href: '#' }, 'Layout'),
            h('a', { class: 'navbar-item', href: '#' }, 'Form'),
            h('hr', { class: 'navbar-divider' }),
            h('a', { class: 'navbar-item', href: '#' }, 'Elements'),
            h('a', { class: 'navbar-item is-active', href: '#' }, 'Components')
          ])
        ])
      ]),
      h('div', { class: 'navbar-end' }, h('div', { class: 'navbar-item' }, h('div', { class: 'field is-grouped' }, [
        h('p', { class: 'control' }, h('a', { class: 'bd-tw-button button', href: '#' }, [
          h('span', { class: 'icon' }, h('i', { class: 'fab fa-twitter' })),
          h('span', {}, 'Tweet')
        ])),
        h('p', { class: 'control' }, h('a', { class: 'button is-primary', href: '#' }, [
          h('span', { class: 'icon' }, h('i', { class: 'fas fa-download' })),
          h('span', {}, 'Download')
        ]))
      ])))
    ])
  ])
}
